import { scheduledTransactionEditFormFactory } from 'app-components/flux/scheduled-transactions/scheduledTransactionEditForm';
import type { ScheduledTransactionEditSubmitArg } from 'app-components/flux/scheduled-transactions/scheduledTransactionEditForm';
import { createFormHooks } from 'app-components/utils/createForm/formHooks';

export const { FormProvider, ...scheduledTransactionEditFormHooks } = createFormHooks(
  scheduledTransactionEditFormFactory,
  {
    additionalSubmitArg: {} as ScheduledTransactionEditSubmitArg,
  },
);
